import { AuthorisedRoute } from 'core/router/AuthorisedRoute';
import React from 'react';
import { Switch } from 'react-router-dom';
import { RolesProvider } from './context/RolesProvider';
import { EditRolePage } from './sections/edit-role/EditRolePage';
import { NewRoleWizardPage } from './sections/new-role/components/NewRoleWizardPage';
import { ViewRolesPage } from './sections/view-roles/ViewRolesPage';

export const RolesBasePage: React.FC = () => {
  return (
    <RolesProvider>
      <Switch>
        <AuthorisedRoute
          path="/user-management/roles/"
          exact={true}
          component={ViewRolesPage}
          requiredAccessLevel="SaleCycle"
          requiredPermissions={['ManageUsers']}
        />
        <AuthorisedRoute
          path="/user-management/roles/create"
          component={NewRoleWizardPage}
          requiredAccessLevel="SaleCycle"
          requiredPermissions={['ManageUsers']}
        />
        <AuthorisedRoute
          path="/user-management/roles/:roleId"
          component={EditRolePage}
          requiredAccessLevel="SaleCycle"
          requiredPermissions={['ManageUsers']}
        />
      </Switch>
    </RolesProvider>
  );
};
